import { create } from 'zustand';

export type AlertRequest = {
  title: string;
  content: string;
  closeText?: string;
  onClose: () => void;
};

export type AlertState = {
  isOpen: boolean;
  alertRequest: AlertRequest;
};

export type AlertActions = {
  openAlert: (request: AlertRequest) => void;
  closeAlert: () => void;
};

export type AlertStore = AlertState & AlertActions;

export const useAlertStore = create<AlertStore>((set, get) => ({
  isOpen: false,
  alertRequest: {
    title: '',
    content: '',
    onClose: () => {},
  },

  openAlert: (request: AlertRequest) => {
    set({ alertRequest: request, isOpen: true });
  },

  closeAlert: () => {
    const { alertRequest } = get();
    alertRequest.onClose();
    set({ isOpen: false });
  },
}));
